import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { pick } from 'ramda';
import { clsx } from '@core/js/utils/classNames.util';
import { useAppSelector } from '@core/js/store/hooks';
import { throttle } from 'underscore';
import { componentService } from '@core/js/services/component.service';
import { LAYER_POSITION } from '@core/js/components/system/Router/constants';

import style from './GoTopButton.scss';

export const GoTopButton: React.FC = () => {
    const [showGoTop, setShowGoTop] = useState<boolean>(false);
    const { cookiesConfiguration: { layerPosition } } = useAppSelector(pick(['cookiesConfiguration']));
    const cookiesIsBottomPosition = layerPosition === LAYER_POSITION.BOTTOM;
    const className = useMemo((): string => clsx([
        style.button,
        cookiesIsBottomPosition && style.cookiesIsBottom
    ]), [cookiesIsBottomPosition]);

    const getScrollElement = useCallback((): HTMLElement => {
        return (document.scrollingElement || document.documentElement) as HTMLElement;
    }, []);

    const checkVisibility = useCallback(() => {
        const scrollEl = getScrollElement();
        const scrollTotal = scrollEl.scrollHeight - scrollEl.clientHeight;
        setShowGoTop(scrollTotal > 0 && window.pageYOffset / scrollTotal > 0.5);
    }, [getScrollElement]);

    const handleScrollUp = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        const throttledCheckVisibility = throttle(checkVisibility, 200);

        window.addEventListener('scroll', throttledCheckVisibility);

        return () => {
            window.removeEventListener('scroll', throttledCheckVisibility);
            throttledCheckVisibility.cancel();
        };
    }, [checkVisibility]);

    return showGoTop ? <div className={className} onClick={handleScrollUp}></div> : null;
};

componentService.registerWebContentComponents({ GoTopButton });
